<template>
  <div
    class="bigger"
    :style="{ backgroundImage: 'url(' + drawBiggerBgp + ')' }"
  >
    <!-- <div> -->
    <div
      class="prize_container"
      :style="{
        border:
          settingBigger.showType === 'popup'
            ? `10px solid #a8baf6`
            : `10px solid #F9B79D`
      }"
    >
      <div class="flex flex-center">
        <div
          class="winning-head flex flex-center item-center"
          :style="{ backgroundImage: 'url(' + winningHeadBgp + ')' }"
        >
          中奖记录
        </div>
      </div>
      <div class="winning-list">
        <animateList
          :List="List"
          :colorStyle="
            settingBigger.showType === 'popup' ? '#5d00e3' : '#DD5302'
          "
        ></animateList>
      </div>
    </div>
    <div class="grid_container">
      <div
        v-if="settingBigger.showType === 'popup'"
        class="grid"
        :style="{
          backgroundImage: 'url(' + drawBiggerTurn + ')'
        }"
      >
        <div class="frame_view" ref="prize">
          <div
            :style="{ webkitTransform: 'translateY( -' + ulLeftTrun + 'px)' }"
          >
            <div class="flex flex-wrap flex-between">
              <div
                class="times-wrapper"
                v-for="(v, i) in mallAwardsList"
                :key="i"
              >
                <div class="imgbox flex flex-center item-center">
                  <img class="img" :src="v.prizeImg" alt="" />
                </div>
                <div class="text-center prize-name">
                  {{ v.prizeLevel }}
                </div>
              </div>
            </div>
            <div class="flex flex-wrap flex-between">
              <div
                class="times-wrapper"
                v-for="(v, i) in mallAwardsList"
                :key="i"
              >
                <div class="imgbox flex flex-center item-center">
                  <img class="img" :src="v.prizeImg" alt="" />
                </div>
                <div class="text-center prize-name">
                  {{ v.prizeLevel }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="roll"
        :style="{
          backgroundImage: 'url(' + drawBiggerTurn + ')'
        }"
      >
        <div class="roll-prize-wrapper flex item-center " ref="rollprize">
          <!-- 老虎机 -->
          <div
            id="rollList"
            class="roll-list flex item-center quick rolls rowup"
            :style="{ webkitTransform: 'translateX( -' + ulLeftTrun + 'px)' }"
          >
            <!-- <div class="flex item-center" v-for="item in ratio" :key="item"> -->
            <div class="flex item-center">
              <div
                class="roll-item flex flex-column item-center flex-center"
                v-for="(v, i) in mallAwardsList"
                :key="i"
              >
                <div class="img-wrapper">
                  <img class="img" :src="v.prizeImg" alt="" />
                </div>
                <div class="prize-name">{{ v.prizeLevel }}</div>
              </div>
            </div>
            <div class="flex item-center">
              <div
                class="roll-item flex flex-column item-center flex-center"
                v-for="v in mallAwardsList"
                :key="v.id"
              >
                <div class="img-wrapper">
                  <img class="img" :src="v.prizeImg" alt="" />
                </div>
                <div class="prize-name">{{ v.prizeLevel }}</div>
              </div>
            </div>

            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div @click="popup">
      dwadwadwadwad
    </div> -->

    <!-- 中奖 -->
    <div
      class="winning-popup"
      v-if="winningVisible && settingBigger.showType === 'popup'"
    >
      <div class="text-center tip-popup">
        中奖啦
      </div>
      <div class="flex box-popup flex-between item-center">
        <div class="flex item-center">
          <div class="head-portrait mr10">
            <img
              :src="
                currentWinning.wechatAvatar ||
                  'https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2098.png'
              "
              alt=""
            />
          </div>
          <div class="mr10">
            {{ phoneEmailShow(currentWinning.memberMobile) }}
          </div>
        </div>
        <div>{{ currentWinning.memberName }}</div>
        <div>获得 {{ currentWinning.prizeLevel }}</div>
      </div>
    </div>

    <div
      class="winning-text-popup"
      v-if="winningVisible && settingBigger.showType === 'text'"
    >
      <div class="flex flex-center">
        <div class="head-portrait">
          <img
            :src="
              currentWinning.wechatAvatar ||
                'https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83erhhic8hpR2l4WqcPdF3qjx0ldiaGoAEsmHd6WB3vE8kWqTu3utIaP2xz0CPJNhV80w7ECga8NHg3dA/132'
            "
            alt=""
          />
        </div>
      </div>
      <div class="flex flex-center size">
        恭喜{{ phoneEmailShow(currentWinning.memberMobile || "11111111111") }}
      </div>
      <div class="flex flex-center size">
        {{ currentWinning.memberName || "张珊珊" }}
      </div>
      <div class="flex flex-center ">
        <div class="btn">获得 {{ currentWinning.prizeLevel || "一等奖" }}</div>
      </div>
    </div>

    <!-- BGM -->
    <audio
      loop="loop"
      id="audio"
      ref="audio"
      :src="
        settingBigger.gameBgm ||
          'https://imgcdn.hemiao100.com/ThemePictures/gameBgm.mp3'
      "
    ></audio>

    <!-- 获奖BGM -->
    <audio
      id="audiowinning"
      ref="audiowinning"
      :src="
        settingBigger.winningBgm ||
          'https://imgcdn.hemiao100.com/ThemePictures/winningBgm.mp3'
      "
    ></audio>
    <div
      class="music"
      @click="playMusic"
      :style="{
        color: settingBigger.showType === 'popup' ? 'orchid' : 'beige'
      }"
    >
      <div class="hmicon icon-music" :class="{ play: isPlay }"></div>
    </div>
  </div>
</template>

<script>
import { phoneEmailShow } from "@/utils/utils";
import animateList from "@/components/animateList";
export default {
  components: {
    animateList
  },

  name: "custom-clone",
  display: "Clone",
  order: 2,
  data() {
    return {
      winningHeadBgp: "https://imgcdn.hemiao100.com/ThemePictures/winning.png",
      rollbgp: "https://imgcdn.hemiao100.com/ThemePictures/rollbgp.png",
      rolltitle: "https://imgcdn.hemiao100.com/ThemePictures/rolltitle.png",
      roll: "https://imgcdn.hemiao100.com/ThemePictures/roll.png",
      isPlay: false,
      currentWinning: {},
      winningVisible: false,
      List: [
        // { name: "1", phone: "11111111111", time: "2021/01/12" },
        // { name: "2", phone: "11111111111", time: "2021/01/13" },
        // { name: "3", phone: "11111111111", time: "2021/01/14" },
        // { name: "4", phone: "11111111111", time: "2021/01/15" },
        // { name: "5", phone: "11111111111", time: "2021/01/16" },
        // { name: "6", phone: "11111111111", time: "2021/01/17" },
        // { name: "7", phone: "11111111111", time: "2021/01/18" },
        // { name: "8", phone: "11111111111", time: "2021/01/19" },
        // { name: "9", phone: "11111111111", time: "2021/01/20" },
        // { name: "10", phone: "11111111111", time: "2021/01/21" },
        // { name: "一", phone: "11111111111", time: "2021/01/22" },
        // { name: "二", phone: "11111111111", time: "2021/01/23" }
      ],
      prizeUlHeightTrun: 0, //滚动ref高度
      prizeUlWidthTrun: 0,
      ulLeftTrun: 0, //移动参数
      phoneEmailShow,
      prizeUlHeight: 0, //滚动ref高度
      $prizeUl: null, //滚动的ref
      ulLeft: 0, //移动参数
      info: {
        joinList: [
          {
            mobile: "18912341211",
            name: "书包1"
          },
          {
            mobile: "18912341222",
            name: "书包2"
          },
          {
            mobile: "18912341233",
            name: "书包3"
          },
          {
            mobile: "18912341244",
            name: "书包4"
          },
          {
            mobile: "18912341255",
            name: "书包5"
          }
        ]
      },
      drawBiggerBgp:
        "https://imgcdn.hemiao100.com/ThemePictures/drawBiggerBgp.png",
      drawBiggerTurn:
        "https://imgcdn.hemiao100.com/ThemePictures/drawBiggerTurn.png",
      circleBg:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%B5%84%E6%BA%90%201.png",
      rotateDeg: 0,
      mallAwardsList: [
        // {
        //   prizeRuleId: "46ba40353a1045799d8136f40f7c75f6",
        //   gameId: "995cb7f46eee4804847e3a8721ef3f33",
        //   prizeName: "80积分",
        //   rankingSeqNum: "二等奖",
        //   prizeType: "1",
        //   prizeNum: 30,
        //   typeValue: "80",
        //   turntableRuleId: "e6918e7e0074409284daa2ba9367c473",
        //   prizeImg:
        //     "https://imgcdn.hemiao100.com/42010216070190/goodsCenter/2021-04-01/1617266097193-7c1ccc36-ed84-4308.png",
        //   winningRate: 30.0,
        //   storeCode: "42010216070190"
        // },
        // {
        //   prizeRuleId: "587ae1482383447ea4fb973dbc72a041",
        //   gameId: "995cb7f46eee4804847e3a8721ef3f33",
        //   prizeName: "笔",
        //   rankingSeqNum: "三等奖",
        //   prizeType: "3",
        //   prizeNum: 60,
        //   typeValue: "笔",
        //   turntableRuleId: "e6918e7e0074409284daa2ba9367c473",
        //   prizeImg:
        //     "https://imgcdn.hemiao100.com/42010216070190/goodsCenter/2021-04-01/1617266264844-3a89ae31-71e0-4aaa.png",
        //   winningRate: 45.0,
        //   storeCode: "42010216070190"
        // },
        // {
        //   prizeRuleId: "db23e5903d3041bf8c891bd9177a04cf",
        //   gameId: "995cb7f46eee4804847e3a8721ef3f33",
        //   prizeName: "100积分",
        //   rankingSeqNum: "一等奖",
        //   prizeType: "1",
        //   prizeNum: 50,
        //   typeValue: "100",
        //   turntableRuleId: "e6918e7e0074409284daa2ba9367c473",
        //   prizeImg:
        //     "https://imgcdn.hemiao100.com/42010216070190/goodsCenter/2021-04-01/1617257283079-c81e2aaf-9bc3-446f.png",
        //   winningRate: 20.0,
        //   storeCode: "42010216070190"
        // },
        // {
        //   prizeImg: "https://imgcdn.hemiao100.com/decoration/sad.png",
        //   prizeName: "谢谢惠顾"
        // },
        // {
        //   prizeRuleId: "db23e5903d3041bf8c891bd9177a04cf",
        //   gameId: "995cb7f46eee4804847e3a8721ef3f33",
        //   prizeName: "100积分",
        //   rankingSeqNum: "一等奖",
        //   prizeType: "1",
        //   prizeNum: 50,
        //   typeValue: "100",
        //   turntableRuleId: "e6918e7e0074409284daa2ba9367c473",
        //   prizeImg:
        //     "https://imgcdn.hemiao100.com/42010216070190/goodsCenter/2021-04-01/1617257283079-c81e2aaf-9bc3-446f.png",
        //   winningRate: 20.0,
        //   storeCode: "42010216070190"
        // }
        // {
        //   prizeRuleId: "46ba40353a1045799d8136f40f7c75f6",
        //   gameId: "995cb7f46eee4804847e3a8721ef3f33",
        //   prizeName: "80积分",
        //   rankingSeqNum: "二等奖",
        //   prizeType: "1",
        //   prizeNum: 30,
        //   typeValue: "80",
        //   turntableRuleId: "e6918e7e0074409284daa2ba9367c473",
        //   prizeImg:
        //     "https://imgcdn.hemiao100.com/42010216070190/goodsCenter/2021-04-01/1617266097193-7c1ccc36-ed84-4308.png",
        //   winningRate: 30.0,
        //   storeCode: "42010216070190"
        // },
        // {
        //   prizeImg: "https://imgcdn.hemiao100.com/decoration/sad.png",
        //   prizeName: "谢谢惠顾"
        // }
      ],
      popupVisible: false,
      socket: "",
      ruleId: this.$route.query.ruleId,
      awaitWinningList: [],
      pointerBg:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png",
      timer: null,
      stabilization: true,
      settingBigger: {},
      audio: ""
    };
  },
  computed: {
    len() {
      return this.mallAwardsList.length;
    },
    turnNum() {
      return 1 / this.len;
    }
  },
  created() {},
  beforeDestroy() {
    // cancelAnimationFrame(this.times); //清理原生的监听
    cancelAnimationFrame(this.timesTrun); //清理原生的监听
    // 销毁监听
    if (typeof this.socket === "object") {
      this.socket.close();
    }

    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    //WebSocket
    this.init();

    this.timer = setInterval(this.scroll, 1000);
    this.queryDrawRecordList();
    this.queryDetails();
    this.queryOfflineDrawUiRel();
  },
  methods: {
    playMusic() {
      setTimeout(() => {
        if (this.isPlay) {
          this.audio.pause();
        } else {
          this.audio.play();
        }
        this.isPlay = !this.isPlay;
      }, 0);
    },
    async queryOfflineDrawUiRel() {
      const { result } = await this.$store.dispatch("queryOfflineDrawUiRel", {
        ruleId: this.ruleId
      });
      this.settingBigger = result;
      if (result.showType === "text") {
        this.drawBiggerBgp = this.rollbgp;
        this.drawBiggerTurn = this.roll;
        this.winningHeadBgp = this.rolltitle;
        // if (this.mallAwardsList.length > 3) {
        this.prizeUlWidthTrun = this.$refs.rollprize.clientWidth;
        this.timesTrun = requestAnimationFrame(this.animateTrun);
        // }
      } else {
        setTimeout(() => {
          this.prizeUlHeightTrun = this.$refs.prize.clientHeight;
          this.timesTrun = requestAnimationFrame(this.animateTrun);
        }, 10);
      }

      // 播放音乐
      this.audio = this.$refs.audio;
      this.audio.onended = function() {
        //播放完毕，重新循环播放
        this.audio.load();
        this.audio.play();
      };
      //开始播放
      this.audio.volume = 0.5;
      this.audio.play();
      this.isPlay = true;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("detailsStoreOfflineDraw", {
        id: this.ruleId
      });

      this.mallAwardsList = result.prizeModelList[0].drawPrizeModelList;
      this.queryArrLength(this.mallAwardsList);
      console.log("this.mallAwardsList: ", this.mallAwardsList);
      // this.queryOfflineDrawUiRel();
    },
    async queryDrawRecordList() {
      const { result } = await this.$store.dispatch("queryDrawRecordList", {
        id: this.ruleId
      });

      result.forEach(v => {
        v.memberName = v.memberName.substring(0, 1) + "**";
      });
      this.List = result;
    },
    scroll() {
      if (this.awaitWinningList.length && this.stabilization) {
        this.stabilization = false;
        this.currentWinning = this.awaitWinningList[0];
        this.popup();
        this.List.push(this.currentWinning);
        this.awaitWinningList.shift();
      }
    },
    queryArrLength(arr) {
      let length = arr.length;
      if (this.settingBigger.showType === "popup") {
        if (length > 3) {
          if (length % 2 !== 0) {
            arr.push({
              prizeImg: "https://imgcdn.hemiao100.com/decoration/sad.png",
              prizeLevel: "谢谢惠顾",
              id: Math.ceil(Math.random() * 100000)
            });
          }
        } else {
          const len = 4 - length;
          for (let i = 0; i < len; i++) {
            arr.push({
              prizeImg: "https://imgcdn.hemiao100.com/decoration/sad.png",
              prizeLevel: "谢谢惠顾",
              id: Math.ceil(Math.random() * 100000)
            });
          }
        }
      } else {
        if (length < 3) {
          arr.push({
            prizeImg: "https://imgcdn.hemiao100.com/decoration/sad.png",
            prizeLevel: "谢谢惠顾",
            id: Math.ceil(Math.random() * 100000)
          });
        }
      }
    },
    init() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        // this.socket = new WebSocket(this.$wsAddress);
        this.socket = new WebSocket(this.$wsAddress + "/order/" + this.ruleId);
        console.log("this.socket: ", this.socket);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    open() {},
    error() {},
    getMessage(msg) {
      console.log("msg: ", msg);
      const originData = msg.data;
      if (originData) {
        console.log("originData: ", originData);
        let row = JSON.parse(originData);
        console.log("心跳链接---- 中奖");

        const { ruleId } = JSON.parse(originData);

        if (ruleId === this.ruleId) {
          row.memberName = row.memberName.substring(0, 1) + "**";
          this.awaitWinningList.push(row);
        }
      }
    },
    //弹起中奖框
    popup() {
      this.winningVisible = true;
      let oAudio = this.$refs.audiowinning;
      oAudio.volume = 0.9;
      oAudio.play();
      setTimeout(() => {
        this.winningVisible = false;
        this.stabilization = true;
      }, 5000);
    },
    animateTrun() {
      requestAnimationFrame(this.animateTrun);
      this.changeAnimationTrun();
    },
    // 编写动画
    changeAnimationTrun() {
      if (
        this.ulLeftTrun ==
        (this.settingBigger.showType === "popup"
          ? this.prizeUlHeightTrun
          : this.prizeUlWidthTrun)
      ) {
        this.ulLeftTrun = 0;
      } else {
        this.ulLeftTrun += 1;
        // if (Number.isInteger(this.ulLeftTrun / 200)) {
        //   console.log("this.ulLeftTrun: ", this.ulLeftTrun);
        //   this.mallAwardsList.push(this.mallAwardsList[0]);
        //   this.mallAwardsList.push(this.mallAwardsList[1]);
        //   // this.mallAwardsList.shift();
        //   this.mallAwardsList.splice(0, 2);
        //   console.log("this.mallAwardsList: ", this.mallAwardsList);
        // }
      }
      // console.log("this.ulLeftTrun: ", this.ulLeftTrun);
    },
    lottery() {
      this.getResult(3, "谢谢惠顾");
    },
    animate() {
      requestAnimationFrame(this.animate);
      this.changeAnimation();
    },
    // 编写动画
    changeAnimation() {
      if (this.ulLeft == this.prizeUlHeight) {
        this.ulLeft = 0;
      } else {
        this.ulLeft += 1;
      }
    },
    //初始化转盘指针
    initializeTurntable() {
      const circleDeg = 360; // 一圈的度数
      const singleDeg = circleDeg / this.mallAwardsList.length / 2; // 单个元素的度数
      this.rotateDeg = singleDeg;
      setTimeout(() => {
        this.flag = false;
      }, 1000);
    },
    getResult(selectedIndex, prizeName) {
      const turn = 1; // 圈数
      const circleDeg = 360; // 一圈的度数
      const singleDeg = circleDeg / this.mallAwardsList.length; // 单个元素的度数
      if (selectedIndex) {
        this.rotateDeg = turn * circleDeg - selectedIndex * singleDeg;
      } else {
        this.rotateDeg = turn * circleDeg;
      }
      // 抽中谢谢惠顾
      if (selectedIndex === this.mallAwardsList.length - 1) {
        this.popupType = "noPrize";
      } else {
        this.popupType = "prize";
        this.prizeName = prizeName;
      }
      setTimeout(() => {
        this.popupVisible = true;
        // this.initializeTurntable();
        this.resetModalVisible();
      }, 2 * 1000); // 6秒后转完
    },
    resetModalVisible() {
      // 领奖后重置转盘
      this.rotateDeg = 0;
      this.mallAwardsList = [...this.mallAwardsList];
      // if (this.residueCount > 0) {
      //   if (this.ruleId) {
      //     this.queryLotteryDetails();
      //   } else {
      //     this.queryTurnTableIndex();
      //   }
      // }
      setTimeout(() => {
        this.popupVisible = false;
        // this.inTheDraw = false; // 解除抽奖按钮禁用
        // this.clickLuck = "clickLuck";
      }, 100);
    }
  }
};
</script>

<style scoped lang="scss">
// .turnTable {
//   // position: absolute;
//   height: 330px;
//   // left: 50%;
//   // top: 55%;
//   // transform: translate(-50%, -50%);

//   .circle {
//     // position: absolute;
//     height: 320px;
//     width: 320px;
//     z-index: 20;
//     // background: url("https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%B5%84%E6%BA%90%201.png");
//     background-repeat: no-repeat;
//     background-size: 100% 100%;
//     left: 50%;
//     transform: translateX(-50%);
//     border-radius: 50%;
//   }

//   .btn {
//     font-size: 14px;
//     background: #fddb00;
//     color: #ff363e;
//     box-shadow: 0 0 8px 1px rgba(239, 33, 6, 0.1) inset;
//     border: 1px solid transparent;
//     border-radius: 30px;
//     padding: 3.5px 14px;
//   }

//   .prize {
//     margin-left: 42px;
//   }

//   .rule {
//     margin-right: 42px;
//   }
// }
// .gb-wheel-container ul,
// .gb-wheel-container li,
// .gb-wheel-container p {
//   margin: 0;
//   padding: 0;
// }

// .gb-wheel-container ul,
// .gb-wheel-container li {
//   list-style: none;
// }

// .gb-wheel-container {
//   margin: 0 auto;
//   position: relative;
//   width: 320px;
//   height: 320px;
//   border-radius: 50%;
//   overflow: hidden;
// }
// .animate {
//   transition: transform 1s ease;
// }
// .gb-wheel-line {
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: inherit;
//   height: inherit;
//   z-index: 99;
// }

// .gb-wheel-litem {
//   position: absolute;
//   left: 140px;
//   top: 0;
//   width: 1px;
//   height: 140px;
//   background-color: #fff;
//   overflow: hidden;
//   transform-origin: 50% 140px;
//   opacity: 0.2;
// }
// .gb-wheel-content {
//   position: absolute;
//   left: 21px;
//   top: 21px;
//   z-index: 2;
//   width: 280px;
//   height: 280px;
//   box-sizing: border-box;
//   border-radius: inherit;
//   background-size: 12px 14px;
// }
// .gb-wheel-list {
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 9999;
// }
// .gb-wheel-item {
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: 100%;
//   height: 100%;
//   font-weight: bold;
// }
// .gb-wheel-icontent {
//   position: relative;
//   display: block;
//   padding-top: 21px;
//   margin: 0 auto;
//   text-align: center;
//   transform-origin: 50% 140px;
//   .img-wrapper {
//     margin: 0 auto;
//     .img {
//       margin-top: 5px;
//       width: 25px;
//       height: 25px;
//     }
//   }
//   p {
//     color: #fff;
//   }
// }

// .gb-wheel-itext {
//   font-size: 16px;
//   font-weight: lighter;
// }
// .gb-wheel-money [class*="icono-"] {
//   color: #fff;
// }
// .gb-wheel-btn {
//   z-index: 400;
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   transform: translate(-50%, -50%);
//   height: 90px;
//   line-height: 104px;
//   width: 71px;
//   color: #fff;
//   text-align: center;
//   // background: url("https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png");
//   background-size: 100%;
//   background-repeat: no-repeat;
//   border: none;
//   font-size: 20px;
// }

// a.gb-wheel-btn {
//   border-bottom: none;
// }

// .gb-wheel-btn.disabled,
// .gb-wheel-btn.disabled::after {
//   pointer-events: none;
//   background: #b07a7b;
//   color: #ccc;
// }
.bigger {
  height: 100vh;
  font-size: 14px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 4px;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.prize_container {
  overflow: hidden;
  width: 500px;
  height: calc(100vh - 265px);
  background: #fff;
  position: fixed;
  top: 10%;
  left: 10%;
  border-radius: 12px;
  padding: 10px;
  // border: 10px solid #a8baf6;
  box-sizing: border-box;
  margin-right: 10px;
}
.winning-popup {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/t_bg%402x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: fixed;
  left: 0;
  top: -30%;
  right: 0;
  bottom: 0;
  width: 1000px;
  height: 500px;
  margin: auto;
  .tip-popup {
    margin-top: 195px;
    font-size: 34px;
    font-weight: bold;
    color: #ffed32;
  }
  .box-popup {
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    padding: 0 240px;
    margin-top: 23px;
    .head-portrait {
      width: 38px;
      height: 38px;

      img {
        width: 100%;
        border-radius: 50%;
      }
    }
  }
}

.winning-text-popup {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/t_bg%402x%20(1).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: fixed;
  left: 0;
  top: -30%;
  right: 0;
  bottom: 0;
  width: 1000px;
  height: 600px;
  margin: auto;
  .head-portrait {
    margin-top: 180px;
    img {
      width: 76px;
      height: 76px;
      border-radius: 50%;
    }
  }
  .btn {
    border-radius: 34px;
    background: #dd5302;
    color: #fff;
    text-align: center;
    padding: 10px 30px;
    font-size: 24px;
    line-height: 35px;
  }
  .size {
    font-size: 33px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ef3d00;
    line-height: 60px;
  }
}

.prize_list {
  border-radius: 12px;
}
.prize_ul {
  // width: 200px;

  // padding: 0px 80px;
  .prize_item {
    // line-height: 50px;
  }
}

.turnTables {
  .circle {
    width: 590px;
    height: calc(100vh - 265px);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    z-index: 22;
    // padding: 50px;
    .times-box {
      width: 440px;
      height: 390px;
      margin-top: 95px;
      margin-left: 50px;
      box-sizing: border-box;
      overflow: hidden;
      .times-wrapper {
        width: 49%;
        box-sizing: border-box;
        background: #fdfff2;
        border-radius: 14px;
        margin-bottom: 10px;
        padding: 10px 10px 5px 10px;
        .imgbox {
          padding: 0 10px 5px 10px;
        }
        .img {
          width: 100%;
        }
        .prize-name {
          font-size: 27px;
          color: #2b2b2b;
        }
      }
    }
  }
}

.winning-head {
  width: 300px;
  height: 90px;
  // background-image: url("https://imgcdn.hemiao100.com/ThemePictures/winning.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  font-weight: 600;
  color: #ffffff;
  font-size: 21px;
}
.winning-list {
  padding: 20px;
}
.grid_container {
  width: 650px;
  position: fixed;
  top: 10%;
  right: 10%;
}
.grid {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 22;
  width: 570px;
  height: 710px;
  position: relative;
  .frame_view {
    position: absolute;
    left: 90px;
    top: 137px;
    width: 400px;
    height: 400px;
    overflow: hidden;
    .times-wrapper {
      width: 49%;
      height: 190px;
      box-sizing: border-box;
      background: #fdfff2;
      border-radius: 14px;
      margin-bottom: 10px;
      padding: 10px 10px 5px 10px;
      .imgbox {
        padding: 0 10px 5px 10px;
      }
      .img {
        width: 150px;
        height: 150px;
      }
      .prize-name {
        font-size: 20px;
        color: #2b2b2b;
        font-weight: bold;
      }
    }
  }
}
.roll {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 22;
  width: 650px;
  height: 710px;
  position: relative;
  .roll-prize-wrapper {
    position: absolute;
    top: 157px;
    left: 72px;
    width: 500px;
    border-radius: 10px;
    height: 229px;
    overflow: hidden;
    z-index: -1;
    .roll-item {
      width: 158px;
      height: 200px;
      border-radius: 10px;
      background: #fff;
      flex-shrink: 0;
      margin-right: 10px;
    }
    .prize-name {
      font-size: 18px;
      font-weight: bold;
    }
    .img-wrapper {
      .img {
        height: 116px;
        width: 116px;
        border-radius: 5px;
        margin-bottom: 12px;
      }
    }
    //   .roll-list {
    //     -webkit-animation: 10s rowup linear infinite normal;
    //     animation: 10s rowup linear infinite normal;
    //     // &.rolls {
    //     //   animation: slowRoll 10s linear infinite normal;
    //     // }
    //     // &.quick {
    //     //   animation: slowRoll 1s linear infinite normal;
    //     // }
    //   }
    // }
    // @keyframes rowup {
    //   0% {
    //     -webkit-transform: translateX(0);
    //     transform: translateX(0);
    //   }

    //   100% {
    //     -webkit-transform: translateX(-507px);
    //     transform: translateX(-507px);
    //   }
    // }
  }
}
.music {
  position: fixed;
  top: 50px;
  right: 80px;
  z-index: 11;

  .hmicon {
    font-size: 56px;
    display: block;
    // color: orchid;
  }

  .play {
    animation: rotate 2s infinite linear;
  }

  @keyframes rotate {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(1turn);
    }
  }
}
</style>
